/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_Restrict_DescInputs */

const en_privacy_rights_item_restrict_desc = /** @type {(inputs: Privacy_Rights_Item_Restrict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 18) — Request restriction of processing of your personal data`)
};

const de_privacy_rights_item_restrict_desc = /** @type {(inputs: Privacy_Rights_Item_Restrict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 18) — Einschraenkung der Verarbeitung Ihrer personenbezogenen Daten verlangen`)
};

const fr_privacy_rights_item_restrict_desc = /** @type {(inputs: Privacy_Rights_Item_Restrict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 18) — Demander la limitation du traitement de tes données personnelles`)
};

const es_privacy_rights_item_restrict_desc = /** @type {(inputs: Privacy_Rights_Item_Restrict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 18) — Solicitar la limitación del tratamiento de tus datos personales`)
};

const it_privacy_rights_item_restrict_desc = /** @type {(inputs: Privacy_Rights_Item_Restrict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 18) — Richiedere la limitazione del trattamento dei tuoi dati personali`)
};

const nl_privacy_rights_item_restrict_desc = /** @type {(inputs: Privacy_Rights_Item_Restrict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 18) — Beperking van de verwerking van je persoonsgegevens verzoeken`)
};

const pl_privacy_rights_item_restrict_desc = /** @type {(inputs: Privacy_Rights_Item_Restrict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 18) — Żądanie ograniczenia przetwarzania Twoich danych osobowych`)
};

const fi_privacy_rights_item_restrict_desc = /** @type {(inputs: Privacy_Rights_Item_Restrict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (18 artikla) — Pyydä henkilötietojesi käsittelyn rajoittamista`)
};

const da_privacy_rights_item_restrict_desc = /** @type {(inputs: Privacy_Rights_Item_Restrict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 18) — Anmod om begrænsning af behandlingen af dine persondata`)
};

const sv_privacy_rights_item_restrict_desc = /** @type {(inputs: Privacy_Rights_Item_Restrict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 18) — Begär begränsning av behandlingen av dina personuppgifter`)
};

/**
* | output |
* | --- |
* | "(Art. 18) — Request restriction of processing of your personal data" |
*
* @param {Privacy_Rights_Item_Restrict_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_restrict_desc = /** @type {((inputs?: Privacy_Rights_Item_Restrict_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_Restrict_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_restrict_desc(inputs)
	if (locale === "fr") return fr_privacy_rights_item_restrict_desc(inputs)
	if (locale === "es") return es_privacy_rights_item_restrict_desc(inputs)
	if (locale === "it") return it_privacy_rights_item_restrict_desc(inputs)
	if (locale === "nl") return nl_privacy_rights_item_restrict_desc(inputs)
	if (locale === "pl") return pl_privacy_rights_item_restrict_desc(inputs)
	if (locale === "fi") return fi_privacy_rights_item_restrict_desc(inputs)
	if (locale === "da") return da_privacy_rights_item_restrict_desc(inputs)
	if (locale === "sv") return sv_privacy_rights_item_restrict_desc(inputs)
	return en_privacy_rights_item_restrict_desc(inputs)
});